var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgWaleeMono = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237.809,
    height: 106.357,
    viewBox: "0 0 237.809 106.357",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    width: 230.42,
    height: 59.755,
    fill: "#1c5800"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280",
    transform: "matrix(0.978, -0.208, 0.208, 0.978, 0, 47.907)",
    opacity: 0.494
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    "data-name": "Group 279",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M1874.618,98.988l0-3.862a1.217,1.217,0,0,1,1.216-1.216h6.284a1.44,1.44,0,0,0,1.439-1.438V89.429h-5.907a6.276,6.276,0,0,1-4.594-1.881,6.393,6.393,0,0,1-1.881-4.758V77.255a6.422,6.422,0,0,1,6.475-6.474h4.469a6.491,6.491,0,0,1,6.516,6.474V92.472a6.562,6.562,0,0,1-6.516,6.516Zm3.033-23.334a1.458,1.458,0,0,0-1.6,1.6v5.7a1.458,1.458,0,0,0,1.6,1.6h5.907v-7.3a1.4,1.4,0,0,0-1.439-1.6Z",
    transform: "translate(-1658.215 -62.725)",
    fill: "#1c5800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M1173.043,36.665c-4.006-.734-5.954-3.113-5.954-7.271V21.073a.054.054,0,0,1,.054-.054h2.777a2.9,2.9,0,0,1,2.9,2.9v5.471a1.718,1.718,0,0,0,1.718,1.718H1215.8l.1-.027c1.107-.3,1.356-2.185,1.356-2.821,0-.976-.626-1.535-1.718-1.535h-4.269a.122.122,0,0,1-.088-.037.135.135,0,0,1-.039-.1,5.433,5.433,0,0,1,5.426-5.42H1236.8l.219-.2a2.94,2.94,0,0,0,.37-.4,3.555,3.555,0,0,0,.662-1.541,10.015,10.015,0,0,0,.154-1.831V.531a.531.531,0,0,1,.62-.524l5.394.838a.153.153,0,0,1,.129.151v4.7c0,.065.008.115.008.146V19.276a7.964,7.964,0,0,1-.149,1.557l-.006.034a11.763,11.763,0,0,1-.244,1.259,5.249,5.249,0,0,1-1.382,2.465,6.951,6.951,0,0,1-2.835,1.608c-.046.015-.094.028-.141.042l-.111.032-.016.006a7.276,7.276,0,0,1-2.477.448h-.018l-.032,0c-1.187.115-2.489.17-4,.17-1.348,0-2.728-.043-4.062-.085s-2.714-.085-4.048-.085h-2.035v1.535c0,2.829-.972,6.346-3.7,7.733a5.816,5.816,0,0,1-2.8.667Z",
    transform: "translate(-1034.261 0)",
    fill: "#1c5800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M15.208,153.055c-.516,1.961-2.543,7.486-3.3,9.733a.389.389,0,0,1-.37.264H7.17A.389.389,0,0,1,6.8,162.8c-.86-2.322-5.738-17.041-6.786-20.449a.39.39,0,0,1,.375-.5h5.5a.389.389,0,0,1,.378.29c.5,1.879,2.99,10.345,3.294,11.4.327-1.106,2.818-9.527,3.314-11.4a.389.389,0,0,1,.378-.29h4.228a.39.39,0,0,1,.378.291c.485,1.855,2.866,10.053,3.193,11.158.25-.871,2.014-6.64,2.906-9.673a2.473,2.473,0,0,1,2.372-1.776h3.852a.39.39,0,0,1,.375.505c-1.053,3.409-5.963,18.129-6.826,20.45a.389.389,0,0,1-.366.253H19a.389.389,0,0,1-.37-.264c-.765-2.247-2.9-7.773-3.419-9.734",
    transform: "translate(0 -125.701)",
    fill: "#1c5800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M450.495,84.025a4.775,4.775,0,0,1-1.345-.326,2.45,2.45,0,0,1-.988-.726,2.5,2.5,0,0,1-.464-1.089,7.916,7.916,0,0,1-.121-1.452V57.764a.369.369,0,0,0-.428-.364l-5.27.849a.369.369,0,0,0-.31.364V81.643a12.392,12.392,0,0,0,.343,3.044,4.872,4.872,0,0,0,1.29,2.3,6.292,6.292,0,0,0,2.58,1.472,14.464,14.464,0,0,0,3.933.558.37.37,0,0,0,.374-.307l.726-4.254a.369.369,0,0,0-.322-.428",
    transform: "translate(-391.314 -50.863)",
    fill: "#1c5800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M271.738,136.17a14.048,14.048,0,0,1,4.478.61,6.963,6.963,0,0,1,2.87,1.75,6.448,6.448,0,0,1,1.527,2.768,13.674,13.674,0,0,1,.448,3.623v12.327a.36.36,0,0,1-.286.353q-1.262.265-3.337.61a34.834,34.834,0,0,1-5.618.386,17.808,17.808,0,0,1-3.765-.366,8.166,8.166,0,0,1-2.911-1.2,5.489,5.489,0,0,1-1.873-2.178,7.512,7.512,0,0,1-.651-3.3,6.246,6.246,0,0,1,.753-3.175,5.8,5.8,0,0,1,2.015-2.076,9.118,9.118,0,0,1,2.89-1.119,16.232,16.232,0,0,1,3.379-.346,19.276,19.276,0,0,1,2.1.1,9.371,9.371,0,0,1,1.486.265v-.57a3.358,3.358,0,0,0-.936-2.483,4.534,4.534,0,0,0-3.257-.936,20.8,20.8,0,0,0-3.053.224,14.085,14.085,0,0,0-2.21.495.359.359,0,0,1-.462-.288l-.657-4.147a.36.36,0,0,1,.257-.4q.438-.123,1.016-.256.794-.183,1.73-.326t1.974-.244q1.038-.1,2.1-.1m.489,17.748q.895,0,1.71-.041a11.71,11.71,0,0,0,1.3-.122v-4.6q-.366-.081-1.1-.163a12.265,12.265,0,0,0-1.343-.081,12.079,12.079,0,0,0-1.608.1,4.206,4.206,0,0,0-1.323.387,2.265,2.265,0,0,0-.9.773,2.152,2.152,0,0,0-.326,1.221,2.08,2.08,0,0,0,.957,1.975,5.284,5.284,0,0,0,2.626.549",
    transform: "translate(-232.731 -120.672)",
    fill: "#1c5800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M548.845,125.773a26.222,26.222,0,0,1-4.427,5.69c-3.641,3.416-7.793,4.113-11.322.115a7.377,7.377,0,0,1,.023-9.67,7.088,7.088,0,0,1,8.314-1.5l-3.911,4.75a.86.86,0,0,0,.117,1.21l3,2.467a.86.86,0,0,0,1.21-.117l7.011-8.514a.575.575,0,0,0-.027-.762l-1.356-1.427a12.678,12.678,0,1,0-2.994,19.792,15.856,15.856,0,0,0,5.948-6.016c.569-.938,1.28-2.082,2.1-3.288Z",
    transform: "translate(-465.789 -101.095)",
    fill: "#1c5800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M761.119,116.746a12.607,12.607,0,0,0-12.638-2.932c-3.86,1.418-6.708,5.891-8.785,9.062-.077.117-.151.232-.225.347l3.772,2.8c3.721-5,9.053-9.932,14.019-5.215a7.078,7.078,0,0,1-7.656,11.641l3.624-4.749a.86.86,0,0,0-.162-1.205l-3.085-2.354a.86.86,0,0,0-1.205.162l-6.631,8.689a.575.575,0,0,0,.061.766l1.448,1.376a12.678,12.678,0,0,0,17.462-18.385",
    transform: "translate(-655.311 -100.283)",
    fill: "#1c5800"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 0.488,
    height: 37.264,
    transform: "translate(120.495 0.242)",
    fill: "#1c5800"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Technologies_Pvt._Ltd.",
    "data-name": "Technologies Pvt. Ltd.",
    transform: "translate(48.177 55.731)",
    fill: "#1c5800",
    fontSize: 13,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: "-0.043em"
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "echnologies "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.007em"
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "vt. Ltd."))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWaleeMono, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/walee-mono.113fc4b0.svg";
export { ForwardRef as ReactComponent };